import React, { ChangeEvent } from 'react'

import { InlineMenu, Input, SectionSubtitle, Textarea } from '../..'
import { useUser } from '../../../context'
import { AnyProfile, Profesor } from '../../../types'
import { Spacer } from '../../global'
import { ProfesorsExperienceContainer } from '../styles'

const ProfessorsSection = ({
  type,
  editedProfile,
  handleMenuChange,
  handleChange,
}: {
  type?: string | null
  editedProfile: AnyProfile
  handleMenuChange: (
    filterName: string,
    value: string | string[] | null,
  ) => void
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}) => {
  const { onEditionMode } = useUser()
  const inNewUser = type === 'new-user' ? true : onEditionMode

  return (
    editedProfile && (
      <>
        <Spacer height={40} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Clases
        </SectionSubtitle>
        <Spacer height={16} />
        <InlineMenu
          menuName="experticeMenu"
          userType="admin"
          activeFilter={editedProfile.activities}
          setActiveFilter={(value) => handleMenuChange('activities', value)}
          isDisabled={!inNewUser}
          isProfile={true}
        />
        <Spacer height={40} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Aptitudes/ estudios
        </SectionSubtitle>
        <Spacer height={16} />
        <InlineMenu
          menuName="experienceMenu"
          userType="admin"
          activeFilter={editedProfile.experienceType}
          setActiveFilter={(value) => handleMenuChange('experienceType', value)}
          isDisabled={!inNewUser}
          isProfile={true}
        />
        <Spacer height={40} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Experiencia (en años)
        </SectionSubtitle>
        <Spacer height={16} />
        <ProfesorsExperienceContainer>
          <div>
            <SectionSubtitle fontWeight={400} fontSize={14} textAlign="center">
              Antigüedad en la metodologia
            </SectionSubtitle>
            <Spacer height={13} />
            <Input
              type="number"
              name="yearsTeaching"
              id="yearsTeaching"
              placeholder={(
                editedProfile as Profesor
              ).yearsTeaching?.toString()}
              defaultValue={(editedProfile as Profesor).yearsTeaching}
              disabled={!inNewUser}
              onChange={handleChange}
              inputClass="profession-data profile-input"
            />
            <Spacer height={13} />
            <SectionSubtitle fontWeight={400} fontSize={14} textAlign="center">
              años
            </SectionSubtitle>
          </div>
          <div>
            <SectionSubtitle
              fontWeight={400}
              fontSize={14}
              textAlign="center"
              className="break-line"
            >
              Experiencia artistica
            </SectionSubtitle>
            <Spacer height={13} />
            <Input
              type="number"
              name="yearsOfExperience"
              id="yearsOfExperience"
              placeholder={(
                editedProfile as Profesor
              ).yearsOfExperience?.toString()}
              defaultValue={(editedProfile as Profesor).yearsOfExperience}
              disabled={!inNewUser}
              onChange={handleChange}
              inputClass="profession-data profile-input"
            />
            <Spacer height={13} />
            <SectionSubtitle fontWeight={400} fontSize={14} textAlign="center">
              años
            </SectionSubtitle>
          </div>
          <div>
            <SectionSubtitle fontWeight={400} fontSize={14} textAlign="center">
              Espectaculos realizados
            </SectionSubtitle>
            <Spacer height={13} />
            <Input
              type="number"
              name="yearsSinging"
              id="yearsSinging"
              placeholder={(editedProfile as Profesor).yearsSinging?.toString()}
              defaultValue={(editedProfile as Profesor).yearsSinging}
              disabled={!inNewUser}
              onChange={handleChange}
              inputClass="profession-data profile-input"
            />
          </div>
          <div>
            <SectionSubtitle fontWeight={400} fontSize={14} textAlign="center">
              Acompaño a
            </SectionSubtitle>
            <Spacer height={13} />
            <Input
              type="number"
              name="yearsOfMethodology"
              id="yearsOfMethodology"
              placeholder={(
                editedProfile as Profesor
              ).yearsOfMethodology?.toString()}
              defaultValue={(editedProfile as Profesor).yearsOfMethodology}
              disabled={!inNewUser}
              onChange={handleChange}
              inputClass="profession-data profile-input"
            />
            <Spacer height={13} />
            <SectionSubtitle fontWeight={400} fontSize={14} textAlign="center">
              alumnos
            </SectionSubtitle>
          </div>
        </ProfesorsExperienceContainer>
        <Spacer height={40} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Biografìa
        </SectionSubtitle>
        <Spacer height={16} />
        <Textarea
          type="biography"
          name="biography"
          id="biography"
          placeholder={(editedProfile as Profesor).biography}
          defaultValue={(editedProfile as Profesor).biography}
          readOnly={!inNewUser}
          onChange={handleChange}
          height={100}
          inputClass="profile-input"
        />
      </>
    )
  )
}

export default ProfessorsSection
